import {
  startViewsReducerPerformanceMeasure,
  VIEWS_REDUCER_PERFORMANCE_MIN_DURATION_MS,
} from './reducerPerformance';

export const IMMER_PERFORMANCE_MIN_DURATION_MS =
  VIEWS_REDUCER_PERFORMANCE_MIN_DURATION_MS;

/**
 * Starts a synchronous views Immer measurement and returns an idempotent
 * callback that reports actions exceeding the configured duration threshold.
 */
export function startImmerPerformanceMeasure(actionType: string): () => void {
  return startViewsReducerPerformanceMeasure('immer', actionType);
}
